import PropTypes from 'prop-types';
import React from 'react';

import Layout from '../Layout';

import './SinglePageLayout.scss';

export default class SinglePageLayout extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        PAGE_PROPS: PropTypes.shape({
            headerProps: PropTypes.object,
            footerProps: PropTypes.object,
            socialLikes: PropTypes.object,
        }).isRequired,
        hasBottomBanner: PropTypes.bool,
    };

    static defaultProps = {
        hasBottomBanner: true,
    };

    static Header = ({ children }) => <div className="header">{children}</div>;
    static Content = ({ children }) => (
        <div className="content">{children}</div>
    );

    render() {
        const { PAGE_PROPS, children } = this.props;

        return (
            <div className="component-Layout-SinglePageLayout">
                <Layout
                    PAGE_PROPS={PAGE_PROPS}
                    hasBottomBanner={this.props.hasBottomBanner}
                >
                    {children}
                </Layout>
            </div>
        );
    }
}
